export const TopicProfile = Object.freeze({
    MISSING_TOPIC: "The following topics were not found in any XML file: "
});